import(/* webpackMode: "eager" */ "/opt/build/repo/app/(chat)/alerts/[id]/page.tsx");
